<template>


  <div style="max-width:650px;margin:0px auto;padding-top:25px;">
 

<h3 class="mb-5">
    Updates
</h3>
<div class="mb-5">What's new, exciting and sometimes not so to anyone else.</div>

 <v-timeline
        align-top
        dense
      >
        <v-timeline-item
          color="green"
      
            v-for="(item,i) in updates"
      :key="i"
        >
        <v-card><v-card-text>
      <v-row class="pt-1">
            <v-col cols="3">
              <strong>{{item.Date}}</strong>
            </v-col>
            <v-col>
              <strong>{{item.Title}}</strong>
              <div class="caption mb-2">
                         {{item.Detail}}     </div>
              <v-avatar>
                <v-img
                  src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown"
                ></v-img>
              </v-avatar>
            </v-col>
          </v-row>
</v-card-text></v-card>
        </v-timeline-item>
 </v-timeline>




  </div>
</template>



<script>



export default {
  name: 'Home',
  
  created: function () {
    // `this` points to the vm instance
   
  },
  computed:{
  
  },
  data(){
    return {  
   
   updates:[   {Title:"Various Location Updates", Detail:"Can add your locations, and modify them too.", Date:"2020-14-01"},{Title:"Updates Page + Settings Page", Detail:"Details", Date:"2020-11-07"},
   {Title:"Release", Detail:"Released into the wild", Date:"2020-11-01"},
   
      ]
    }
  },

  methods: {
    
   
  },
  components: {

  }
}
</script>

